import food from "../assets/images/food.jpg"
import health from "../assets/images/health.jpg"
import education from "../assets/images/education.jpg"
import travel from "../assets/images/travel.jpg"
import fitness from "../assets/images/fitness.jpg"
import entertainment from "../assets/images/entertainment.jpg"
import world from "../assets/images/world.jpg"
import all from "../assets/images/all.jpg"

export const categories =
    [
        { name: "All", id: 'ALL', background: all },
        { name: "Food", id: 'FOOD', background: food },
        { name: "Health", id: 'HEALTH', background: health },
        { name: "Education", id: 'EDUCATION', background: education },
        { name: "Travel", id: 'TRAVEL', background: travel },
        { name: "Fitness", id: 'FITNESS', background: fitness },
        { name: "Entertainment", id: 'ENTERTAINMENT', background: entertainment },
        { name: "World", id: 'WORLD', background: world }
    ]